import { AppClientRootModule, AppClientUIModule } from '@sdbn/appclient';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  { path: '', loadChildren: () => AppClientRootModule },
  { path: '**', loadChildren: () => AppClientRootModule },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {

  constructor() {
    console.log('AppRoutingModule');
  }

}
